import { Box, Button, styled } from '@mui/material';

export const StyledActionsBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVertical'
})<{ isVertical: boolean }>(({ theme, isVertical }) => ({
  display: 'flex',
  flexDirection: isVertical ? 'column' : 'row',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

/**
 * Sized against the icon buttons beside it rather than against MUI's default button, so the strip
 * keeps one row height whether an action carries a label or not.
 */
export const StyledToolbarButton = styled(Button)(({ theme }) => ({
  height: theme.spacing(8),
  whiteSpace: 'nowrap',
  textTransform: 'none'
}));
